<template>
    <div>
        <div v-for="(item,i) in dataList" :key="i" class="flex justify-between padding-tb-sm border-b cursor"  @click="onDetail(item.descrId)">
            <img :src='item.filePath' style="width:174px" />
            <div style="width:790px;height:116px" class="margin-left-sm">
                <p class="text-bold text-df ">{{item.vipName}}</p>
                <p class="text-sm text-grey descr">{{item.shortDescription}}</p>
                <p class="text-sm primary cursor">详情>></p>
            </div>
        </div>
        <el-pagination @current-change="getData" :current-page.sync="currentPage" :page-size="10"
            layout="prev, pager, next, jumper" :total="total" class="fr margin-top">
        </el-pagination>
    </div>
</template>
<script>
    import api from "@/utils/api"
    export default {
        data() {
            return {
                dataList: [],
                currentPage: 1,
                total: 0
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            async getData() {
                let res = await api.getVipDescribeApi({
                    pageNum: this.currentPage,
                    pageSize: 10
                })
                if (res.code == 200) {
                    this.dataList = res.data.list
                    this.total = res.data.total
                }
            },
            onDetail(id) {
                let name = this.$route.name
                this.$router.push({
                    path: '/memberCenter/detail',
                    query: {
                        name,
                        id
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .border-b {
        border-bottom: 1px solid #EDEDED;
    }

    .descr {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: wrap;
        line-height: 20px;
    }
</style>